import { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { fetchAuthSession } from 'aws-amplify/auth';

import {
  fetchUnreadCountByPatientId,
  subscribeToNewNotificationsByPatientId,
  subscribeToUpdatedNotificationsByPatientId
} from '../../InAppNotification/services/apiService';
import { notMatchCustomErrorMessage } from '@/lib/sentryClient';
import * as Sentry from '@sentry/react';

const NotificationAlert = () => {
  const [unreadCount, setUnreadCount] = useState<number>(0);

  const updateUnreadCount = async (patientId: string) => {
    try {
      const count = await fetchUnreadCountByPatientId(patientId);
      setUnreadCount(count);
    } catch (error) {
      if (error instanceof Error && notMatchCustomErrorMessage(error.name)) {
        Sentry.captureException(error);
      }
      console.error('Failed to fetch unread count:', error);
    }
  };

  useEffect(() => {
    let newNotificationSub: any;
    let updatedNotificationSub: any;

    const checkUnreadNotifications = async () => {
      try {
        const session = await fetchAuthSession();
        const patientId = session?.userSub;

        if (patientId) {
          await updateUnreadCount(patientId);

          // サブスクリプションで通知を監視
          newNotificationSub = subscribeToNewNotificationsByPatientId(
            patientId,
            () => updateUnreadCount(patientId),
            (error) => console.error('New Notification Subscription Error:', error)
          );
          updatedNotificationSub = subscribeToUpdatedNotificationsByPatientId(
            patientId,
            () => updateUnreadCount(patientId),
            (error) => console.error('Updated Notification Subscription Error:', error)
          );
        }
      } catch (error) {
        console.error('Failed to check unread notifications:', error);
      }
    };

    checkUnreadNotifications();

    return () => {
      if (newNotificationSub) newNotificationSub.unsubscribe();
      if (updatedNotificationSub) updatedNotificationSub.unsubscribe();
    };
  }, []);

  // 未読がない場合、何も表示しない
  if (unreadCount === 0) return null;

  return (
    <Alert
      severity="info"
      icon={<ErrorOutlineIcon />}
      sx={{
        mb: 2,
        alignItems: 'center',
        backgroundColor: 'white',
        color: 'red',
        fontWeight: 'bold',
        justifyContent: 'flex-start',
        '& .MuiAlert-icon': { color: 'red' }
      }}
    >
      通知が{unreadCount}件あります
    </Alert>
  );
};

export default NotificationAlert;
